import { useCallback, useState } from "react";
import { useIntl } from "react-intl";

import { getIsEditable, getOpenMapStudyArea } from "../../../store/selectors";
import { usePublicationStore } from "../../../store/store";

export function useStudyAreaControl() {
  const intl = useIntl();

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const studyArea = usePublicationStore(getOpenMapStudyArea);
  const isEditable = usePublicationStore(getIsEditable);

  const openAddModal = useCallback(() => setIsAddModalOpen(true), []);
  const closeAddModal = useCallback(() => setIsAddModalOpen(false), []);
  const openRemoveModal = useCallback(() => setIsRemoveModalOpen(true), []);
  const closeRemoveModal = useCallback(() => setIsRemoveModalOpen(false), []);

  const tooltipLabel = studyArea
    ? intl.formatMessage(
        {
          id: "publication.study_area.tooltip",
          defaultMessage: "Study area from file {layerInFile}",
        },
        { layerInFile: studyArea.filePath ?? "" }
      )
    : undefined;

  return {
    isAddModalOpen,
    isRemoveModalOpen,
    studyArea,
    tooltipLabel,
    isEditable,
    openAddModal,
    closeAddModal,
    openRemoveModal,
    closeRemoveModal,
  };
}
